import gql from "graphql-tag";

import type {GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {
    hideProgramFromHotlist as Data,
    hideProgramFromHotlistVariables as Variables,
} from "./__graphql-types__/hideProgramFromHotlist.ts";

export const HIDE_PROGRAM_FROM_HOTLIST: GqlOperation<Data, Variables> = gqlOp(
    gql`
        mutation hideProgramFromHotlist($programID: ID!, $hide: Boolean!) {
            hideProgramFromHotlist(programID: $programID, hide: $hide) {
                error {
                    code
                    debugMessage
                }
            }
        }
    `,
);

export async function hideProgramFromHotlist(
    gqlFetch: GqlFetchFn,
    programID: string,
    hide: boolean,
): Promise<void> {
    try {
        const data = await gqlFetch(HIDE_PROGRAM_FROM_HOTLIST, {
            variables: {programID, hide},
        });

        if (data?.hideProgramFromHotlist?.error) {
            throw new KAError(
                "hideProgramFromHotlist returned an error",
                Errors.Internal,
                {
                    cause: JSON.stringify(data?.hideProgramFromHotlist?.error),
                },
            );
        }
    } catch (e: any) {
        throw new KAError(
            "Error hiding a program from hotlist",
            Errors.Internal,
            {
                cause: e,
            },
        );
    }
}
